function splitMessages(topicMessages, lastCount, isOwn) {
  const { list, refTime, totalCount } = topicMessages;
  const sortByCreated = (a, b) => topicMessages[a].created > topicMessages[b].created ? 1 : -1;
  const result = { before: [], after: [], ...topicMessages };
  if (!list || list.length === 0) {
    return result;
  }
  if (!refTime) {
    return { before: list, ...result };
  }
  const sortedList = list.slice(0).sort(sortByCreated);
  sortedList.forEach((id) => {
    if (topicMessages[id].created > refTime) {
      result.after.push(id);
    } else {
      result.before.push(id);
    }
  });
  result.newCount = totalCount - lastCount;
  for (let ownIndex = result.after.length - 1; ownIndex >= 0; ownIndex--) {
    if (isOwn(topicMessages[result.after[ownIndex]].createdBy)) {
      result.before = [...result.before, ...result.after.slice(0, ownIndex + 1)];
      result.after = result.after.slice(ownIndex + 1);
      break;
    }
  }
  result.newCount = result.after.length;
  result.lastTime = topicMessages[sortedList[sortedList.length - 1]].created;
  return result;
}

export default splitMessages;
